export var InfoBarMessageSource;
(function (InfoBarMessageSource) {
    InfoBarMessageSource[InfoBarMessageSource["Compose"] = 0] = "Compose";
    InfoBarMessageSource[InfoBarMessageSource["Extensibility"] = 1] = "Extensibility";
    InfoBarMessageSource[InfoBarMessageSource["ReadingPane"] = 2] = "ReadingPane";
})(InfoBarMessageSource || (InfoBarMessageSource = {}));
export var InfoBarMessageRank;
(function (InfoBarMessageRank) {
    InfoBarMessageRank[InfoBarMessageRank["Safety"] = 0] = "Safety";
    InfoBarMessageRank[InfoBarMessageRank["Error"] = 1] = "Error";
    InfoBarMessageRank[InfoBarMessageRank["Info"] = 2] = "Info";
    InfoBarMessageRank[InfoBarMessageRank["Encryption"] = 3] = "Encryption";
})(InfoBarMessageRank || (InfoBarMessageRank = {}));
export var InfoBarMessageColor;
(function (InfoBarMessageColor) {
    InfoBarMessageColor[InfoBarMessageColor["Grey"] = 0] = "Grey";
    InfoBarMessageColor[InfoBarMessageColor["Red"] = 1] = "Red";
    InfoBarMessageColor[InfoBarMessageColor["Green"] = 2] = "Green";
    InfoBarMessageColor[InfoBarMessageColor["Yellow"] = 3] = "Yellow";
})(InfoBarMessageColor || (InfoBarMessageColor = {}));
//# sourceMappingURL=InfoBarMessageViewState.js.map